import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Wait for Cordova to be ready
const startApp = () => {
  // Configure StatusBar if available
  if (window.StatusBar) {
    window.StatusBar.overlaysWebView(false);
    window.StatusBar.backgroundColorByHexString('#9c6b5f');
    window.StatusBar.styleDefault();
  }
  
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Check if Cordova is available
if (window.cordova) {
  document.addEventListener('deviceready', startApp, false);
} else {
  // Running in browser
  startApp();
}
